import React, { useState } from "react";
import { AddToCart } from "./AddToCart";
import { ScentSelector } from "./ScentSelector";
import { PdpTab } from "./PdpTab";
import { usePdpFocusedScent, usePdpScents, usePdpProduct } from "./PdpContext";
import { Button } from "@/components/Button";

import { MoneyBackIcon, FreeShippingIcon } from "@/components/icons";

export interface CartFlowProps {
  cartAddId: string;
}

function CartFlow({ cartAddId }: CartFlowProps) {
  const focusedScent = usePdpFocusedScent();
  const { pdpTabData, pdpIngredientSection } = usePdpProduct();
  const scents = usePdpScents();
  const [toggleScentOpen, setToggleScentOpen] = useState(false);

  return (
    <div className="grid gap-4">
      {focusedScent !== undefined ? (
        <div className="mb-4">
          <div
            className={`flex items-center justify-between ${
              toggleScentOpen ? "mb-4" : ""
            }`}
          >
            <div
              className="font-myriad-pro-condensed max-w-fit rounded-full px-4 py-2 text-xl font-semibold uppercase text-black"
              style={{ backgroundColor: focusedScent?.color }}
            >
              {focusedScent?.name}
            </div>
            <Button
              variant="text"
              onClick={() => {
                setToggleScentOpen(!toggleScentOpen);
              }}
              style={{ color: "#000" }}
              className="font-semibold normal-case tracking-normal underline"
            >
              {scents.length === 1
                ? toggleScentOpen
                  ? "Hide details"
                  : "Show details"
                : toggleScentOpen
                ? "Hide scent"
                : "Show scent"}
            </Button>
          </div>
          {toggleScentOpen && (
            <div className="px-4">
              <ScentSelector
                focusedScent={focusedScent}
                showBottomPart={false}
              />
              <p className="m-0 text-sm text-gray-700">
                {focusedScent?.description}
              </p>
            </div>
          )}
        </div>
      ) : null}
      <AddToCart cartSubmitId={cartAddId} />

      {pdpTabData &&
        (pdpTabData.overview ||
          pdpTabData.impact ||
          pdpTabData.ingredients) && (
          <PdpTab
            tabData={pdpTabData}
            ingredientTabDrawerData={pdpIngredientSection}
          />
        )}

      <div className="flex justify-center space-x-4 pb-4 pt-0 sm:pb-2 sm:pt-2">
        <div className="flex items-center space-x-2">
          <MoneyBackIcon />
          <p className="body text-sm">
            <strong>30-day</strong> money back guarantee
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <FreeShippingIcon />
          <p className="body text-sm">
            <strong>Free Shipping</strong> on orders over $35
          </p>
        </div>
      </div>
    </div>
  );
}

export default CartFlow;
